import React from "react";
import { Helmet } from "react-helmet-async";

const Privacy: React.FC = () => (
  <>
    <Helmet>
      <title>J&amp;S Audio Video Solutions – Privacy Policy – Central MA</title>
      <meta name="robots" content="noindex, follow" />
      <meta name="description" content="Privacy policy for J&S Audio Video Solutions, the Central Massachusetts audio visual equipment supplier and installer based in Leicester, MA." />
    </Helmet>

    <section className="subhero" data-testid="subhero-privacy">
      <div className="container">
        <span className="eyebrow" style={{ color: "var(--color-accent)" }}>Legal</span>
        <h1>Privacy Policy</h1>
        <p className="lead">How we handle the small amount of information that flows through this website.</p>
      </div>
    </section>

    <section className="section">
      <div className="container container-sm content">
        <p>This Privacy Policy describes how J&amp;S Audio Video Solutions ("we", "us", or "our") handles information collected through this website. The site is currently in a pre-launch state and is not actively marketed or indexed by search engines.</p>

        <h2 className="mt-5">Information we collect</h2>
        <p className="mt-3">We only collect information that you provide directly to us. The contact form on this site asks for your name, phone number, email address, the service you are interested in, and a short message describing your project. We collect this information so we can respond to your inquiry and prepare an estimate.</p>
        <p className="mt-3">We do not collect any payment information through this website. Quotes and invoices are handled separately, in writing, after an initial conversation with you.</p>

        <h2 className="mt-5">How we use your information</h2>
        <ul className="mt-3">
          <li>To respond to your inquiry and schedule a conversation about your project.</li>
          <li>To prepare and send an estimate based on what you've described.</li>
          <li>To follow up after a project, with permission, regarding ongoing technical support.</li>
        </ul>
        <p className="mt-3">We do not use your information for marketing automation, profiling, or behavioral advertising.</p>

        <h2 className="mt-5">Sharing your information</h2>
        <p className="mt-3">We do not sell, rent, or trade your personal information. We will not share your inquiry or contact details with any third party for marketing purposes. The only exception is if we are required to disclose information by law, in response to a valid legal request from a government authority.</p>

        <h2 className="mt-5">Analytics and tracking</h2>
        <p className="mt-3">During the pre-launch phase, this site does not run third-party analytics, advertising pixels, or session-recording tools. Our hosting provider may keep standard server access logs for security and uptime purposes; those logs are not used to track individuals.</p>

        <h2 className="mt-5">Cookies</h2>
        <p className="mt-3">This website does not set tracking cookies. The only client-side storage in use is the small amount required by the site itself to function, which is not used for tracking or advertising.</p>

        <h2 className="mt-5">Your choices and rights</h2>
        <p className="mt-3">You can request a copy of any contact information we hold for you, request that we correct it, or request that we delete it. To make any of these requests, call us at <a href="tel:+15084500490">508-450-0490</a> and ask to speak with someone about a privacy request.</p>

        <h2 className="mt-5">Children's privacy</h2>
        <p className="mt-3">This website is intended for adults inquiring about audio visual installation services. We do not knowingly collect information from anyone under the age of 13.</p>

        <h2 className="mt-5">Changes to this policy</h2>
        <p className="mt-3">We may update this Privacy Policy from time to time. The most current version will always be posted on this page. Material changes will be reflected by updating the date below.</p>

        <h2 className="mt-5">Contact us</h2>
        <p className="mt-3">If you have any questions about this Privacy Policy or how your information is handled, please call <a href="tel:+15084500490">508-450-0490</a>. We are based in Leicester, Massachusetts and serve customers throughout Central Massachusetts and parts of northeastern Connecticut.</p>

        <p className="mt-5" style={{ color: "var(--color-gray-dark)", fontSize: "0.9rem" }}>Last updated: May 2026</p>
      </div>
    </section>
  </>
);

export default Privacy;
